module.exports = __webpack_public_path__ + "a31527daf7b5cc62d6732a1b65968afe.pdf";